
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.812 22H1.188a1.22 1.22 0 01-.839-.327A1.093 1.093 0 010 20.881v-.756c0-.298.123-.583.345-.794.221-.211.522-.33.837-.331h16.63c.315 0 .616.117.839.327.223.21.348.495.349.792v.756c0 .298-.123.583-.345.794-.221.211-.522.33-.837.331h-.006zM16.793 8.105l.853.869a1.24 1.24 0 01.009 1.725l-.009.009-6.796 6.931a1.181 1.181 0 01-1.697.003l-.003-.003-6.796-6.931a1.24 1.24 0 01-.009-1.725l.009-.009.853-.87a1.181 1.181 0 011.697-.002l.003.003 3.29 3.354V1.227C8.197.55 8.734 0 9.397 0h1.207c.318 0 .624.127.85.357.225.23.353.541.353.866V11.46L15.1 8.105a1.177 1.177 0 011.69-.004l.003.004z","fill":"#24C4C8"}})])
          )
        }
      }
    